// Give it some room to be off. Our tokens expire at 15m.
let TWO_MINUTES = 120_000

export function isOutOfSync(remote, local) {
  return Math.abs(local - remote) > TWO_MINUTES
}
